import { Component } from '@angular/core';

@Component({
  selector: 'app-ui-alert',
  templateUrl: './ui-alert.component.html',
  styleUrls: ['./ui-alert.component.css']
})
export class UiAlertComponent {
  /**
   * Header button list show
   */
  Settingicon = true;
  Menuoption = 'center'
}
